export const SAN_CTI_URL =
    "https://ccsslb.sansoftwares.com/callerMini";

export const SAN_CTI_ORIGIN =
    "https://ccsslb.sansoftwares.com";

export const SAN_CTI_EVENTS = {
    READY: "SANAppReadyEvent",
    OUTGOING: "SANAppOutgoingEvent",
    INCOMING: "SANAppIncomingEvent",
    HOLD: "SANAppHoldEvent",
    SAVE_PAGE: "SANAppSavePageEvent",
    MANUAL: "SANAppManualOnOffEvent",
    BREAK: "SANAppBreakEvent",
    INIT: "SANAppInitEvent",
    LOGOUT: "SANAppLogoutEvent",

    CONFERENCE_JOIN: "SANAppConfEventjoin",
    CONFERENCE_DIALING: "conferenceDialing",
    CONFERENCE_LEAVE: "SANAppConfEventLeave",

    SEND_DISPOSITION: "SEND_DISPOSITION",

    TRANSFER: "SANAppTransferEvent",
    CONFERENCE: "SANAppConferenceEvent",
};

export const SAN_CTI_COMMANDS = {
    LOGIN: "login",
    READY: "ready",
    LOGOUT: "Logout",

    DIAL: "dial",
    HANGUP: "Hangup",

    HOLD: "HoldCall",
    UNHOLD: "UnholdCall",

    MUTE: "MuteCall",
    UNMUTE: "UnmuteCall",

    MANUAL_ON: "ManualOn",
    MANUAL_OFF: "ManualOff",

    INCOMING_ACCEPT: "IncAccept",

    CONFERENCE_TOGGLE: "ConfrenceToggle",
    CONFERENCE_NUMBER: "ConfrenceNumber",
    CONFERENCE_HOLD_TOGGLE: "ConfHoldToggle",

    SUBMIT_DISPOSITION: "SubmitDisposition",
};